import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddGuideCommentMutationVariables = Types.Exact<{
  comment?: Types.InputMaybe<Types.Guide_Comments_Insert_Input>;
}>;


export type AddGuideCommentMutation = { __typename?: 'mutation_root', insert_guide_comments_one?: { __typename?: 'guide_comments', id: any } | null };


export const AddGuideCommentDocument = gql`
    mutation addGuideComment($comment: guide_comments_insert_input = {}) {
  insert_guide_comments_one(object: $comment) {
    id
  }
}
    `;
export type AddGuideCommentMutationFn = Apollo.MutationFunction<AddGuideCommentMutation, AddGuideCommentMutationVariables>;

/**
 * __useAddGuideCommentMutation__
 *
 * To run a mutation, you first call `useAddGuideCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGuideCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGuideCommentMutation, { data, loading, error }] = useAddGuideCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddGuideCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddGuideCommentMutation, AddGuideCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGuideCommentMutation, AddGuideCommentMutationVariables>(AddGuideCommentDocument, options);
      }
export type AddGuideCommentMutationHookResult = ReturnType<typeof useAddGuideCommentMutation>;
export type AddGuideCommentMutationResult = Apollo.MutationResult<AddGuideCommentMutation>;
export type AddGuideCommentMutationOptions = Apollo.BaseMutationOptions<AddGuideCommentMutation, AddGuideCommentMutationVariables>;